module.exports = __webpack_public_path__ + "static/media/photo-taken-on-body-of-water-1127032.c6c7f901.jpg";